/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Order_Not_FulfillableInputs */

const en_error_sales_order_not_fulfillable = /** @type {(inputs: Error_Sales_Order_Not_FulfillableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The order has nothing allocated to ship, or is not locked yet.`)
};

/**
* | output |
* | --- |
* | "The order has nothing allocated to ship, or is not locked yet." |
*
* @param {Error_Sales_Order_Not_FulfillableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_order_not_fulfillable = /** @type {((inputs?: Error_Sales_Order_Not_FulfillableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Order_Not_FulfillableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_order_not_fulfillable(inputs)
});